const styles = () => ({
  root: {
    height: '100%',
    position: 'relative',
    width: '100%',
  },
});

export default styles;
